import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './BottomNav.css';

const BottomNav: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const { isAuthenticated, user } = useAuth();

    const tabs = React.useMemo(() => {
        if (!isAuthenticated) {
            return [
                { id: 'home', label: 'Home', icon: '🏠', path: '/' },
                { id: 'search', label: 'Search', icon: '🔍', path: '/marketplace' },
                { id: 'planning', label: 'Planning', icon: '📅', path: '/login' },
                { id: 'invitations', label: 'Invitations', icon: '💌', path: '/invite' },
            ];
        }

        // Admin: Core 4 modules — Guests, Timeline, Budget, Vendors
        if (user?.role === 'admin') {
            return [
                { id: 'home', label: 'Home', icon: '🏠', path: '/welcome' },
                { id: 'guests', label: 'Guests', icon: '👥', path: '/admin/guests' },
                { id: 'budget', label: 'Budget', icon: '💰', path: '/budget' },
                { id: 'vendors', label: 'Vendors', icon: '🏪', path: '/admin/vendors' },
                { id: 'tasks', label: 'Timeline', icon: '📅', path: '/admin/tasks' },
            ];
        }

        if (user?.role === 'superadmin') {
            return [
                { id: 'home', label: 'Home', icon: '🏠', path: '/welcome' },
                { id: 'panel', label: 'Panel', icon: '🔑', path: '/superadmin/dashboard' },
                { id: 'guests', label: 'Guests', icon: '👥', path: '/admin/guests' },
                { id: 'budget', label: 'Budget', icon: '💰', path: '/budget' },
            ];
        }

        // Guest: Core 4 modules
        return [
            { id: 'home', label: 'Home', icon: '🏠', path: '/welcome' },
            { id: 'feed', label: 'Feed', icon: '✨', path: '/dashboard' },
            { id: 'food', label: 'Food', icon: '🍲', path: '/guest/food' },
            { id: 'tasks', label: 'Schedule', icon: '📅', path: '/guest/tasks' },
        ];
    }, [user?.role, isAuthenticated]);

    const isActive = (path: string) => {
        if (path === '/') {
            return location.pathname === '/' || location.pathname === '/home';
        }
        return location.pathname === path;
    };

    return (
        <nav className="bottom-nav">
            <div className="nav-glow"></div>
            <div className="nav-tabs-container">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        id={`bottom-nav-${tab.id}`}
                        className={`nav-tab ${isActive(tab.path) ? 'active' : ''}`}
                        onClick={() => history.push(tab.path)}
                        aria-label={tab.label}
                        aria-current={isActive(tab.path) ? 'page' : undefined}
                    >
                        <div className="tab-icon-wrapper">
                            <span className="tab-icon">{tab.icon}</span>
                            {isActive(tab.path) && <div className="active-indicator"></div>}
                        </div>
                        <span className="tab-label">{tab.label}</span>
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default BottomNav;

